import R from "ramda";
import {
  BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS,
  LOADING_STOP,
  START_FIRST_TIME_BETA_MODE
} from "actions/bootstrap-actions";
import {
  CLEAR_FLASH_MESSAGE,
  SET_FLASH_MESSAGE,
  UNKNOWN_ERROR,
  SET_PENDING_DOCUMENTS,
  SET_UPLOAD_DOCUMENTS_VISIBILITY,
  START_SETTINGS_MODE,
  END_SETTINGS_MODE,
  START_NOTIFICATIONS_MODE,
  END_NOTIFICATIONS_MODE,
  SET_EXPORT_FAILED_COUNT,
  SET_QUEUED_COUNT,
  END_GLOBAL_ERROR,
  END_FIRST_TIME_BETA_MODE,
  TOGGLE_BETA_MODAL,
  START_TOUR,
  END_TOUR
} from "actions/app-actions";

export const initialState = {
  accounts: [],
  exportFailedCount: 0,
  flash: { message: null, type: null },
  selectedAccount: null,
  isDontRemindBeta: false,
  isLoading: true,
  isFirstTimeBetaMode: false,
  isGlobalError: false,
  isNotificationsMode: false,
  isNotificationsViewed: false,
  isSettingsMode: false,
  isTourOpen: false,
  isUploadDocumentsVisible: false,
  isUploadError: false,
  pendingDocuments: [],
  queuedCount: 0,
  tourName: "",
  user: null
};

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOTSTRAP_CURRENT_USER_AND_ACCOUNTS:
      return R.merge(state, currentUserAndAccounts(action.data));
    case LOADING_STOP:
      return R.merge(state, { isLoading: false });
    case UNKNOWN_ERROR:
      return R.merge(state, { isLoading: false, isGlobalError: true });
    case SET_FLASH_MESSAGE:
      return R.merge(state, {
        flash: {
          message: action.data.message,
          type: (action.data.type || "success")
        }
      });
    case CLEAR_FLASH_MESSAGE:
      return R.merge(state, { flash: initialState.flash });
    case START_SETTINGS_MODE:
      return R.merge(state, { isSettingsMode: true });
    case END_SETTINGS_MODE:
      return R.merge(state, { isSettingsMode: false });
    case SET_PENDING_DOCUMENTS:
      return R.merge(state, { pendingDocuments: action.data.documents });
    case SET_UPLOAD_DOCUMENTS_VISIBILITY:
      return R.merge(state, { isUploadDocumentsVisible: action.data.visible });
    case START_NOTIFICATIONS_MODE:
      return R.merge(state, { isNotificationsMode: true, isNotificationsViewed: true });
    case END_NOTIFICATIONS_MODE:
      return R.merge(state, { isNotificationsMode: false });
    case SET_EXPORT_FAILED_COUNT:
      return R.merge(state, { exportFailedCount: action.data.exportFailedCount });
    case SET_QUEUED_COUNT:
      return R.merge(state, { queuedCount: action.data.queuedCount });
    case END_GLOBAL_ERROR:
      return R.merge(state, { isGlobalError: false });
    case START_FIRST_TIME_BETA_MODE:
      return R.merge(state, { isFirstTimeBetaMode: true });
    case END_FIRST_TIME_BETA_MODE:
      return R.merge(state, { isFirstTimeBetaMode: false });
    case TOGGLE_BETA_MODAL:
      return R.merge(state, { isDontRemindBeta: action.data.toggle });
    case START_TOUR:
      return R.merge(state, { isTourOpen: true, tourName: action.data.tour });
    case END_TOUR:
      return R.merge(state, { isTourOpen: false, tourName: "" });
    default:
      return state;
  }
};

const currentUserAndAccounts = (data) => ({
  accounts: R.pathOr([], ["accounts"], data),
  selectedAccount: R.pathOr(null, ["selectedAccount"], data),
  user: R.pathOr(null, ["user"], data)
});



// WEBPACK FOOTER //
// ./src/js/reducers/app-reducer.js